import React from 'react';
const stats = [{
  value: '+500',
  label: 'Tejedoras que ya confían'
}, {
  value: '12',
  label: 'Tomos listos'
}, {
  value: '5',
  label: 'Bonos incluidos'
}, {
  value: '4.9/5',
  label: 'Calificación ⭐'
}];
export function Stats() {
  return <section aria-label="Resultados reales" className="border-y border-white/5 bg-ink-2" data-id="element-144" data-mp="2ixp8giaoukw3">
      <div className="mx-auto max-w-5xl px-5" data-id="element-145" data-mp="2nv7arpu7a1v4">
        <dl className="grid grid-cols-2 gap-6 pb-4 pt-5 sm:grid-cols-4" data-id="element-146" data-mp="298e233f6rubw">
          {stats.map(stat => <div key={stat.label} className="text-center" data-id="element-147" data-mp="2dzdy86ghe8dc">
              <dt className="font-display text-4xl font-black text-silver-shine sm:text-5xl" data-id="element-148" data-mp="2e0p54f583w8o">
                {stat.value}
              </dt>
              <dd className="mt-1 text-sm font-medium text-white/60" data-id="element-149" data-mp="255ra92iim9ep">{stat.label}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}